import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as subawardTermsAndConditionMonitorActivities from '../../subaward-terms-and-condition-monitor-activities'

export const RESOURCE = {
  payload: {
    description:
      'The association(s) of term/condition and monitoring activity. Typically used to automatically apply monitoring activities based on the specified terms and conditions.',
    dimension: subawardTermsAndConditionMonitorActivities.RESOURCE.payload,
    level: 0,
    name: 'Subaward T&C Monitoring Activity Association',
    partialId: PartialId.Standard.create('entry'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
